/***
* Add by hxzhu
* created:20190805
* 注:营销活动首页
*/

<template>
  <div v-if="!activityDataStatus">
    <img :src="logo">
  </div>
  <div class="item-div" v-else v-wechat-title="$route.meta.title=activityData.title">
    <t-p-follow ref="follow" :open-type="0" :subscribe="subscribe" :biz="biz"/>
    <!-- 我要抢购弹出二维码遮罩层开始-->
    <div class="mask service" v-show="showMerchant" @click="closeMerchant">
      <div class="service-div">
        <div class="name-span">商户客服:{{ activityData.launchUser }}</div>
        <div class="phone-div" v-if="activityData.launchPhone != null && activityData.launchPhone != ''">
          <span>{{ activityData.launchPhone }}</span>
          <button class="btn-style" v-on:click.stop="cell">一键拨打</button>
        </div>
        <img :src="imageUrl+activityData.contactImg" style="width:95%;height:95%"/>
        <div class="bottom-text">请扫码联系我们</div>
      </div>
    </div>
    <!-- 购买界面遮罩层开始-->
    <div class="mask buy" v-show="showBuy">
      <div class="buy-div">
        <div class="title">姓名</div>
        <input type="text" placeholder="请输入姓名" v-model="formObj.truename"/>
        <div class="title">手机号</div>
        <input type="text" placeholder="请输入手机号" v-model="formObj.phone"/>
        <button type="button" class="buy-btn" @click="btnBuy()">提交</button>
      </div>
      <img class="close-img" src="../../resource/img/pop_icon_close.png" @click="closeBuy"/>
    </div>
    <!-- 领取礼品界面遮罩层结束-->
    <div class="mask buy" v-show="showBind">
      <div class="bind-div">
        <p>绑定手机号</p>
        <input type="text" placeholder="请输入手机号码" ref="bdphone"/>
        <img class="bind-img" src="../../resource/img/querenbangding.png" alt @click="btnBind(checkType)"/>
      </div>
      <img class="close-img" src="../../resource/img/pop_icon_close.png" @click="closeBindPhone"/>
    </div>
    <!--分享海报 start-->
    <div class="mask poster" v-show="showPoster">
      <div v-if="posterImg == ''" ref="box" class="poster-box">
        <img :src="sharePic" class="top-img"/>
        <div class="user">
          <img class="logo-img" :src="userinfo.headimgurl"/>
          <div class="span-info">
            <span class="user-name">{{ userinfo.nickname }}</span>
            <span class="text-span">邀请你参加</span>
          </div>
        </div>
        <div class="share-title">{{ activityData.shareTitle }}</div>
        <div class="bottom-div">
          <div id="qrcode"></div>
          <div class="discern-div">
            <img class="discern-img" src="../../resource/img/active/icon_discern.png">
            <span class="span-text">长按识别二维进入活动</span>
          </div>
        </div>
      </div>
      <div class="posterImg">
        <span class="title-hint" style="">长按图片保存到相册</span>
        <img :src="posterImg" alt/>
        <img src="../../resource/img/pop_icon_close.png" @click="closePoster"
             style="width: 30px;height: 30px;margin-top: 25px;"/>
      </div>
    </div>
    <!--分享海报 end -->
    <!-- 活动首页头部 头部背景图 -->
    <div class="item-top">
      <img :src="imageUrl+activityData.contentTop" style="width:100%;height: 100%;"/>
      <!-- 修改1：添加遮罩层 弹出二维码 -->
      <div class="top-title" @click="openMerchant">本活动由{{ activityData.launchUser }}发起</div>
      <div class="service" @click="openMerchant" v-if="showContect"></div>
      <div class="poster" @click="draw"></div>
      <img @click="openUserInfo()" src="../../resource/img/active/grzx.png"
           style="position: fixed;top: 30vh;width: 12vw; right: 1vw;background-color: rgba(255, 255, 255, 0.9);border-radius: 50%;"/>
      <img src="../../resource/img/musiclogo.png" class="music-btn" @click="musicAuto" ref="musicInfo"/>
      <audio loop="loop" preload ref="musicPlay" :src="activityData.backgroundMusic"/>
    </div>
    <!-- 活动首页内容-->
    <div class="item-content"
         v-bind:style="{backgroundImage:'url('+imageUrl+activityData.content+')',backgroundSize: '100%'}">
      <!-- 显示活动日期 -->
      <div class="time-div">
        <img src="../../resource/img/pic_time.png" class="time-img"/>
        <div class="time-content" v-if="activityTime == 0">
          <div class="time-title">活动结束倒计时：</div>
          <div class="time-text">{{ daySold }}</div>
          <span>天</span>
          <div class="time-text">{{ hrSold }}</div>
          <span>时</span>
          <div class="time-text">{{ minSold }}</div>
          <span>分</span>
          <div class="time-text">{{ seconds }}</div>
          <span>秒</span>
        </div>
        <div class="time-content" v-if="activityTime == 1">
          <span>活动已经结束</span>
        </div>
        <div class="time-content" v-if="activityTime == 2">
          <span>活动未开始</span>
        </div>
      </div>
      <!-- 显示粉丝数量 观看人数 点亮钻石 红包排名 商品信息 购买记录-->
      <div class="content-div">
        <!-- 显示粉丝数量 观看人数-->
        <div class="sm-icon">
          <div style="margin-right:15vw;">
            <img src="../../resource/img/icon_view.png" style="width:4vw; height:2.87vw;"/>
            <span class="font-s">
              <i>{{ findActivity.viewCount == null ? 0 : findActivity.viewCount }}</i>人查看
            </span>
          </div>
          <div style="margin-right:15vw;">
            <img src="../../resource/img/icon_fans.png" style="width:4vw; height:3.76vw;"/>
            <span>拓展
              <i>{{ findActivity.fansCount == null ? 0 : findActivity.fansCount }}</i>个粉丝
            </span>
          </div>
          <div>
            <img src="../../resource/img/icon_apply.png" style="width:4vw; height:4.12vw;"/>
            <span>
              <i>{{ findActivity.applyCount == null ? 0 : findActivity.applyCount }}</i>人报名
            </span>
          </div>
        </div>
        <!-- 显示nickname和点亮钻石-->
        <div class="user-info">
          <img class="avatar-img" :src="userinfo.headimgurl" alt/>
          <div class="name">{{ userinfo.nickname || 'red1' }}</div>
        </div>
        <template v-if="activityData.isOpenFriends==1">
          <div class="diamond-div" v-if="diamonds==null">
            <img src="../../resource/img/zuanshimeikaiqishi.png" v-for="(n,index) in parseInt(activityData.diamondsNum)"
                 :key="index"/>
          </div>
          <div class="diamond-div" v-else>
            <img src="../../resource/img/gold.png" v-for="(n,index) in parseInt(diamonds.lightDiamondsNum)"
                 :key="index"/>
            <img src="../../resource/img/zuanshimeikaiqishi.png"
                 v-for="(n,index) in parseInt(activityData.diamondsNum-diamonds.lightDiamondsNum)"
                 :key="index"/>
          </div>
          <div class="content-div-text">{{ activityData.slogan || '分享朋友圈，点亮一个钻石，有机会获取红包' }}</div>
        </template>
        <div class="content-div-text" v-if="activityData.isOpenShare==1">{{ '好友助力数:' + shareCount }}</div>
        <!-- 抢购活动 -->
        <img src="../../resource/img/btn.png" v-if="activityTime == 0 && showActivity" class="btn_img"
             @click="btnOrderBuy"/>
        <img src="../../resource/img/btn.png" v-if="activityTime == 0 && showOrder " class="btn_img"
             @click="openOrder"/>
        <!--  待领取红包 -->
        <template v-if="redEnvelope.length > 0">
          <div class="content-title">待领取红包</div>
          <div class="red-envelope-div">
            <div class="content">
              <div class="red-envelope-list" v-for="item in redEnvelope">
                <div class="span-div">
                  {{ item.spreadName }}
                  <span>{{ item.typeName }}，获得{{ item.totolMoney }}</span>元
                  <span>红包</span>
                </div>
                <div class="get-btn" @click="getRedEnvelope(item.id,item.totolMoney)">领取</div>
              </div>
            </div>
          </div>
        </template>
        <!--  红包排名 -->
        <table class="red-envelopes" v-if="spreadList.length!=0"
               :style="{backgroundColor:activityData.bgColor==undefined?'':activityData.bgColor}">
          <caption class="title-caption">
            <img class="img" src="../../resource/img/hongbao.png"/>
            <span class="text">红包排名</span>
          </caption>
          <tr class="top-tr">
            <td style="width:20vw">名次</td>
            <td style="width:60vw">客户</td>
            <td style="width:20vw;">红包</td>
          </tr>
          <marquee behavior="scroll" contenteditable="true" scrollamount="4" direction="up"
                   style="width:90vw;height:auto;" v-if="spreadList.length > 4 ">
            <tr v-for="(items,index) in spreadList" :key="index">
              <td v-if="items.serialNum == 1" style="width:20vw">
                <img src="../../resource/img/jiangpai.png" alt class="ranking-img"/>
              </td>
              <td v-else-if="items.serialNum == 2" style="width:20vw">
                <img src="../../resource/img/tongpai.png" alt class="ranking-img"/>
              </td>
              <td v-else-if="items.serialNum == 3" style="width:20vw">
                <img src="../../resource/img/yinpai.png" alt class="ranking-img"/>
              </td>
              <td v-else style="width:20vw">{{ items.serialNum }}</td>
              <td style="width:60vw">{{ items.nickName }}</td>
              <td style="width:20vw">{{ items.totolMoney }}</td>
            </tr>
            <p></p>
          </marquee>
          <div class="red-paper-rank" style="width:90vw;height:auto;" v-if="spreadList.length <= 4">
            <tr v-for="(items,index) in spreadList" :key="index">
              <td v-if="items.serialNum == 1" style="width: 20vw">
                <img src="../../resource/img/jiangpai.png" alt class="ranking-img"/>
              </td>
              <td v-else-if="items.serialNum == 2" style="width: 20vw">
                <img src="../../resource/img/tongpai.png" alt class="ranking-img"/>
              </td>
              <td v-else-if="items.serialNum == 3" style="width: 20vw">
                <img src="../../resource/img/yinpai.png" alt class="ranking-img"/>
              </td>
              <td style="width: 20vw" v-else>{{ items.serialNum }}</td>
              <td style="width: 60vw">{{ items.nickName }}</td>
              <td style="width: 20vw">{{ items.totolMoney }}</td>
            </tr>
            <p></p>
          </div>
        </table>
        <!--商品信息-->
        <div class="red-paper-list" v-if="listGoods.length!=0"
             :style="{backgroundColor:activityData.bgColor==undefined?'':activityData.bgColor}">
          <div class="goods-content" v-for="(items,index) in listGoods" :key="index">
            <div class="content">
              <img :src="getImgUrl(imageUrl,items.pic)" class="goods-img"/>
              <div class="user-content">
                <span class="name">{{ items.name }}</span>
                <span class="price">价格:{{ items.price }}元</span>
                <span>需要{{ items.buyNum }}位好友</span>
              </div>
              <img v-if="buyerCount < items.buyNum" class="lock-img" src="../../resource/img/suotoumeikaiqishi.png"/>
              <div class="lock-div" v-else>
                <img src="../../resource/img/jiesuo.png" class="lock-img"/>
                <button class="get-btn" @click="getGift(items,index)" v-if="items.status==0" :key="index">领取</button>
                <button class="get-btn" v-else :key="index">已领取</button>
              </div>
            </div>
          </div>
        </div>
        <!--解锁名单 v-model="vmUnlock"-->
        <p style="color:white;font-size: 0.4rem;" v-if="goodsOrder.length!=0">解锁名单</p>
        <div class="Unlockname" v-if="goodsOrder.length!=0">
          <img v-for="(item,index) in goodsOrder" :key="index" :src="item.avatar"
               style="width:8vw;height:8vw;margin-left:2vw;border-radius:10vw"/>
        </div>
        <div class="content-title" v-if="orderList.length!=0" style="margin-top: 20px">购买记录</div>
        <!--购买记录-->
        <div class="order-list" v-if="orderList.length!=0 && activityData.orderDisplayType == 0">
          <table class="table" v-if="orderList.length <= 3">
            <tr v-for="(items,index) in orderList" :key="index" class="tr">
              <td valign="middle" style="text-align:center;">
                <img :src="items.avatar" alt class="avatar-img"/>
              </td>
              <td style="text-align:left;">
                <p>{{ items.nickname }}</p>
                <p>{{ items.payTime }}</p>
              </td>
              <td style="text-align:center;">
                <span>已支付{{ items.payMoney }}</span>
              </td>
            </tr>
          </table>
          <marquee behavior="scroll" direction="up" height="100%" width="100%" scrollamount="5"
                   v-if="orderList.length>3">
            <table class="table">
              <tr v-for="(items,index) in orderList" :key="index" class="tr">
                <td valign="middle" style="text-align:center;">
                  <img :src="items.avatar" alt class="avatar-img"/>
                </td>
                <td style="text-align:left;">
                  <p>{{ items.nickname }}</p>
                  <p>{{ items.payTime }}</p>
                </td>
                <td style="text-align:center;">
                  已支付
                  <span>{{ items.payMoney }}</span>
                </td>
              </tr>
            </table>
          </marquee>
        </div>
        <div class="order-display" v-if="orderList.length!=0 && activityData.orderDisplayType == 1">
          <div v-for="(item,index) in orderList" :key="index">
            <img class="avatar-img" :src="item.avatar"/>
            <span class="name">{{ item.nickname }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动首页尾部  点击抢购  查看我的订单-->
    <div class="item-bottom">
      <img class="bg-img" :src="imageUrl+activityData.contentBottom"/>
      <div style="height: 45px;"></div>
      <div class="fool-img">
        <img class="img" src="../../resource/img/底部按钮.png" alt style="" @click="btnOrderBuy" v-if="showActivity"/>
        <img class="img" src="../../resource/img/myOrder.png" alt @click="openOrder" v-else-if="showOrder==true"/>
      </div>
    </div>
    <div class="form-content">
      <div class="titleInfo" :style="{display:isEnd ? 'block' : 'none'}">
        <div style="height: 30%; background: rgba(248, 248, 248, 1);">
          <font style="font-size: 5vw; margin: 5% 5%;">温馨提醒</font>
        </div>
        <div style="width: 100%; margin: 10% 20%" v-if="activityTime == 1">
          <font style="font-size: 5vw;">该活动已经结束,感谢参与</font>
        </div>
        <div style="width: 100%; margin: 10% 18%" v-if="activityTime == 2">
          <font style="font-size: 5vw;">该活动未开始,期待你的参与</font>
        </div>
        <div style="width: 100%; margin: 10% 18%" v-if="activityTime == 3">
          <font style="font-size: 5vw;">该活动已经结束,感谢参与</font>
        </div>
      </div>
    </div>
    <div class="mask" :style="{display:isMask ? 'block' : 'none'}"
         @click="closeMask"></div>
  </div>
</template>


<script>
import wx from 'weixin-js-sdk'
import {qrcanvas} from 'qrcanvas'
import html2canvas from 'html2canvas'
import TPFollow from '../common/comp/TPFollow'

export default {
  name: 'MerTokerDetail',
  components: {TPFollow},
  data () {
    return {
      isOperate: true,
      index: null,
      shareCount: 0,
      userinfo: {},
      urlParam: {},
      //是否关注过
      subscribe: 0,
      //关注跳转公众号
      biz: null,
      activityData: {
        title: '',
        contentTop: '',
        content: '',
        contentBottom: '',
        contactImg: '',
        activityId: '',
        backgroundMusic: '',
        actName: '',
        diamondsNum: 0,
        lightDiamondsNum: 0,
        startDate: '',
        endDate: '',
        giftGiveRule: '',
        sharePic: '',
        price: 0,
        shareTitle: '',
        launchUser: '',
        launchPhone: '',
        shareDesc: '',
        slogan: '',
        orderDisplayType: 0,
        isOpenFriends: 0,
        isOpenShare: 0,
      },
      spreadList: [],
      orderList: [{
        nickname: '新村男孩',
        avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/Bu5PaCSHYJ1qQVuNb2Cf7PsoLnlHRGrmUibBQic3ibvJSoxFDxJj2AKg9S2uEYibmnER2Piaa7EqCzOZIWtq21hpujA/132'
      }],
      listGoods: [],
      findActivity: {
        viewCount: 0,
        fansCount: 0,
        applyCount: 0
      },
      user: {},
      orderInfo: {},
      txt: 1,
      diamonds: null,
      goodsOrder: [],
      formObj: {
        activityId: 6,
        merId: 19,
        storeId: 53,
        price: 1,
        truename: '',
        phone: '',
        buyNum: 1,
        openid: '',
        nickname: '',
        sex: '1',
        avatar: '',
        remark: '',
        fansid: null,
        sourceType: null
      },
      imageUrl: '',
      showBuy: false,
      showActivity: true,
      showOrder: false,
      buyerCount: 2,
      showMerchant: false,
      showBind: false,
      redEnvelope: [],
      checkType: 1,
      activityTime: 2,
      timeId: null,
      downTimeId: null,
      cutDownTime: 300,
      daySold: '0',
      hrSold: '0',
      minSold: '0',
      seconds: '0',
      isMask: false,
      isEnd: false,
      activityDataStatus: false,
      showContect: false,
      logo: require('../../resource/img/white.png'),
      showPoster: false,
      posterImg: '',
      weixinUrl: this.$common.weixinUrl,
      sharePic: '',
      giftGoods: {},
    }
  },
  created () {
    this.$root.$children[0].pageData = 1
    let timeId = setInterval(this.showDateTime, 1000) //执行的定时器
    this.timeId = timeId
    this.downTimeId = setInterval(this.cutDownTimeFun, 1000)//开始定时器
    //路由接收参数
    this.urlParam = this.$route.query
    this.urlParam.storeId = this.$util.isArrOrNull(this.urlParam.storeId) ? '' : this.urlParam.storeId
    if (this.urlParam.spreadOpenid == undefined) {
      this.urlParam.spreadOpenid = null
    }
    if (this.urlParam != null) {
      this.formObj.activityId = this.urlParam.activityId
      this.formObj.merId = this.urlParam.merId
      this.formObj.storeId = this.urlParam.storeId
      if (this.urlParam.subscribe == 1) {
        this.subscribe = 1
      }
      this.formObj.price = this.urlParam.price
      this.formObj.nickname = this.urlParam.nickname
    }
  },
  mounted () {
    this.$api.getUrl().then(res => {
      this.imageUrl = res
      this.findActivityData()
      this.Wechat()
    }).catch(() => {
    })
  },
  methods: {
    //微信授权
    Wechat () {
      if (!this.$route.query.userInfo) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-market-extend/get/wxcode',
          data: {
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            merId: this.urlParam.merId,
            price: this.urlParam.price,
            spreadOpenid: this.urlParam.spreadOpenid
          },
          login: false
        }).then(res => {
          window.location.href = res.data.url + '?activityId=' + this.urlParam.activityId + '&merId=' + this.urlParam.merId
            + '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price + '&spreadOpenid=' + this.urlParam.spreadOpenid
        })
      } else {
        this.userinfo = JSON.parse(this.$route.query.userInfo)
        this.formObj.sourceType = this.$route.query.sourceType
        this.getData()
        this.getUserOrder()
      }
    },
    //获取活动信息
    getData () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/act-order-info',
        data: {
          activityId: this.urlParam.activityId,
          storeId: this.urlParam.storeId,
          openid: this.userinfo.openid
        },
        login: false
      }).then(res => {
        if (res.data != null) {
          this.spreadList = res.data.spreadList
          this.orderList = res.data.orderList
          this.listGoods = res.data.listGoods
          this.goodsOrder = res.data.goodsOrder
          this.buyerCount = res.data.BuyerCount
          if (res.data.activity != null) {
            this.activityDataStatus = true
            this.activityData = res.data.activity
            //倒计时：
            this.activityData.startDate = this.activityData.startDate.replace(/\-/g, '/')
            this.activityData.endDate = this.activityData.endDate.replace(/\-/g, '/')
            this.activityData.startDate = new Date(Date.parse(this.activityData.startDate))
            this.activityData.endDate = new Date(Date.parse(this.activityData.endDate))
            this.activityData.startDate = this.activityData.startDate.getTime()
            this.activityData.endDate = this.activityData.endDate.getTime()
            //转图片为base64
            this.imageUrlToBase64(this.activityData.sharePic)
            this.$common.activitydata = this.activityData
            if (!this.$util.isArrOrNull(this.activityData.backgroundMusic)) {
              this.$set(this.activityData, 'backgroundMusic', this.imageUrl + this.activityData.backgroundMusic)
            }
            if (!this.$util.isArrOrNull(this.activityData.contactImg)) {
              this.showContect = true
            }
            this.getConfig()
          }
        }
      }).catch(err => {
        this.activityTime = 3
        this.isEnd = true
        this.isMask = true
      })
    },
    getConfig () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/share/config',
        data: {
          merId: this.urlParam.merId,
          url: encodeURIComponent(location.href.split('#')[0])
        },
        login: false
      }).then(res => {
        setTimeout(() => {   //设置延迟执行
          this.$refs.musicPlay.play()
        }, 1000)
        this.biz = res.data.biz
        wx.config({
          appId: res.data.appId, //APPID
          timestamp: res.data.timestamp, //上面main方法中拿到的时间戳timestamp
          nonceStr: res.data.nonceStr, //上面main方法中拿到的随机数nonceStr
          signature: res.data.signature, //上面main方法中拿到的签名signature
          //需要调用的方法接口
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
          ]
        })
        let time
        wx.ready(() => {
          this.$refs.musicPlay.play()
          //需在用户可能点击分享按钮前就先调用
          let titles = this.userinfo.nickname + ' 邀请您' + this.activityData.shareTitle
          let sharePic = this.imageUrl + this.activityData.sharePic
          let desc = this.activityData.shareDesc
          let url = this.weixinUrl + 'MerTokerDetail?activityId=' + this.urlParam.activityId + '&merId=' + this.urlParam.merId +
            '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price + '&spreadOpenid=' + this.userinfo.openid
          wx.updateAppMessageShareData({
            title: titles, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic, // 分享图标
            success: () => {
              clearTimeout(time)
            }
          })
          wx.updateTimelineShareData({
            title: titles, // 分享标题
            link: url, //(window.location.href.split('?'))[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic, // 分享图标
            success: () => {
              this.getDiamonds()
              setTimeout(() => {   //设置延迟执行
                this.getUserRed()
              }, 2000)
            }
          })
        })
        wx.error(res => {
          //location.reload()
          //alert('请点击授权使用完整服务！')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
        // time = setTimeout(() => {   //设置延迟执行
        //   location.reload()
        // }, 1000)
      })
    },
    //异步执行
    imageUrlToBase64 (imageUrl) {
      //一定要设置为let，不然图片不显示
      let image = new Image()
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = this.imageUrl + imageUrl
      //image.onload为异步加载
      image.onload = () => {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let quality = 0.8
        //这里的dataurl就是base64类型
        let dataURL = canvas.toDataURL('image/jpeg', quality)//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        this.sharePic = dataURL
      }
    },
    showDateTime: function () {
      let date = new Date()
      if (!this.$util.isArrOrNull(this.activityData.startDate) && !this.$util.isArrOrNull(this.activityData.endDate)) {
        let timeNew = this.activityData.startDate - date.getTime()
        let timeOld = this.activityData.endDate - date.getTime()
        if (timeOld < 0) {
          window.clearInterval(this.timeId)  //移除定时器
          this.activityTime = 1 //活动已经截止
          clearInterval(this.downTimeId)
        } else if (timeNew > 0) {//活动未开始
          window.clearInterval(this.timeId)  //移除定时器
          this.activityTime = 2
          //添加一个定时器（5分钟的）
          if (timeNew <= 300000) {
            this.cutDownTime = parseInt(timeNew / 1000) + 1
            this.cutDownTimeFun()
          }
        } else {
          clearInterval(this.downTimeId)
          this.activityTime = 0
          let e_daySold = timeOld / 86400000
          let daySold = Math.floor(e_daySold)
          let e_hrSold = (e_daySold - daySold) * 24
          let hrSold = Math.floor(e_hrSold)
          let e_minSold = (e_hrSold - hrSold) * 60
          let minSold = Math.floor((e_hrSold - hrSold) * 60)
          let seconds = Math.floor((e_minSold - minSold) * 60)
          if (daySold < 10) {
            this.daySold = '0' + daySold
          } else {
            this.daySold = daySold
          }
          if (hrSold < 10) {
            this.hrSold = '0' + hrSold
          } else {
            this.hrSold = hrSold
          }
          if (minSold < 10) {
            this.minSold = '0' + minSold
          } else {
            this.minSold = minSold
          }
          if (seconds < 10) {
            this.seconds = '0' + seconds
          } else {
            this.seconds = seconds
          }
        }
      }
    },
    openMerchant () {
      this.showMerchant = true
    },
    cell () {
      window.location.href = 'tel:' + this.activityData.launchPhone
    },
    closeMerchant: function () {
      this.showMerchant = false
    },
    //打开购买订单界面
    getUserOrder () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/user/order',
        data: {
          openid: this.userinfo.openid,
          merId: this.urlParam.merId,
          storeId: this.urlParam.storeId,
          activityId: this.urlParam.activityId
        },
        login: false
      }).then(res => {
        this.order = res.data.order
        this.$common.userinfo = res.data.user
        this.user = res.data.user
        this.diamonds = res.data.diamonds
        this.formObj.fansid = this.user.id
        this.shareCount = res.data.shareCount
        if (!this.$util.isArrOrNull(this.order)) {
          this.showOrder = true
          this.showActivity = false
        }
        this.getUserRed() //获取为领取红包
      })
    },
    //点击购买订单界面
    btnOrderBuy () {
      if (this.$util.isArrOrNull(this.userinfo.openid))
      {
        alert('请点击授权使用完整服务！')
        return
      }
      if (this.activityTime == 1 || this.activityTime == 2) {
        this.isEnd = true
        this.isMask = true
      } else {
        if (!this.$util.isArrOrNull(this.order)) {
          this.showOrder = true
          this.showActivity = false
        } else {
          this.showOrder = false
          this.showActivity = true
          this.showBuy = true
        }
      }
    },
    musicAuto: function (e) {
      let state = this.$refs.musicInfo.style.animationPlayState
      if (state === 'paused') {
        this.$refs.musicInfo.style.animationPlayState = 'running'
        this.$refs.musicPlay.play()
      } else {
        this.$refs.musicInfo.style.animationPlayState = 'paused'
        this.$refs.musicPlay.pause()
      }
    },
    //关闭购买订单界面
    closeBuy: function () {
      this.showBuy = false
    },
    //关闭绑定手机号界面
    closeBindPhone: function () {
      this.showBind = false
    },
    //截取图片路径 显示在页面上面
    getImgUrl: function (name, url) {
      let _urlsArr = url.split(';')
      let _urlArr = _urlsArr[0].split(',')
      let _urlStr
      if (_urlArr != null && _urlArr.length >= 2) {
        _urlStr = name + _urlArr[0] + '/' + _urlArr[1]
      } else {
        _urlStr = name + _urlArr[0]
      }
      return _urlStr
    },
    //提交订单信息
    btnBuy: function () {
      if (this.isOperate) {
        if (this.formObj.truename == null || this.formObj.truename.length < 2) {
          alert('姓名必须大于2个字！')
          return
        }
        let reg = /^1\d{10}$/
        let myreg = /^0\d{2,3}-?\d{7,8}$/
        if (!reg.test(this.formObj.phone) && !myreg.test(this.formObj.phone)) {
          alert('请填写的正确的手机号码格式')
          return
        }
        this.isOperate = false
        this.formObj.openid = this.userinfo.openid
        this.formObj.nickname = this.userinfo.nickname
        this.formObj.fansid = this.user.id
        this.formObj.avatar = this.userinfo.headimgurl
        this.formObj.sourceType = this.formObj.sourceType
        this.$api.post({
          url: '/merchant/api/activity/merchant-market-extend/buy',
          data: this.formObj,
          login: false
        }).then(res => {
          this.orderInfo = JSON.stringify(res.data)
          this.$router.push({
            path: '/MerTokerPay',
            query: {
              orderInfo: this.orderInfo,
              openid: this.userinfo.openid
            }
          })
        }).catch(err => {
          this.isOperate = true
        })
      }
    },
    //查询订单信息
    openOrder () {
      let that = this
      that.$router.push({
        path: '/MerTokerOrder',
        query: {
          activityId: that.urlParam.activityId,
          uid: that.user.uid,
          openid: that.userinfo.openid,
          type: 0
        }
      })
    },
    //查询粉丝报名人数信息
    findActivityData: function () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/activity/datas',
        data: {
          activityId: this.urlParam.activityId,
          merId: this.urlParam.merId,
          storeId: this.urlParam.storeId,
          activityType: 0
        },
        login: false
      }).then(res => {
        this.findActivity = res.data
      })
    },
    //领取礼物方法
    getGiftS: function (phone, codeNum) {
      this.$confirm('是否确认领取,领取后可到店进行核销？',
        '提示',
        {type: 'warning'}).then(() => {
        this.$api.post({
          url: '/merchant/api/activity/merchant-market-extend/receive/product',
          data: {
            activityType: 0,
            activityId: this.urlParam.activityId,
            merId: this.urlParam.merId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            openid: this.userinfo.openid,
            productId: this.giftGoods.id,
            phone: phone,
            codeNum: codeNum,
            buyNum: this.listGoods[this.index].productNum
          },
          login: false
        }).then(res => {
          this.listGoods[this.index].status = true
          this.showBind = false
        })
      })
    },
    //判断是否有uid
    getGift: function (items, index) {
      let that = this
      this.giftGoods = items
      that.index = index
      if (that.user.uid != null) {
        that.getGiftS(null, null)
      } else {
        that.showBind = true
      }
    },
    btnBind (value) {
      let that = this
      if (value == 1) {
        that.getGiftS(null, null)
      } else if (value == 2) {
        that.bind(that.$refs.bdphone.value, null)
      }
    },
    //获取钻石
    getDiamonds: function () {
      if (this.activityData.isOpenFriends == 1 && this.user != null) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-extend-diamonds/save',
          data: {
            activityId: this.activityData.activityId,
            storeId: this.urlParam.storeId,
            merId: this.activityData.merId,
            fansid: this.user.id,
            activityType: 0
          },
          login: false
        }).then(res => {
          this.diamonds = res.data
        })
      }
    },
    //跳转到个人中心界面
    openUserInfo: function () {
      if (this.userinfo.openid == null) {
        this.Wechat()
      } else {
        this.$router.push({
          path: '/MerTokerUserDetail',
          query: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            uid: this.user.uid,
            nickname: this.userinfo.nickname,
            avatar: this.userinfo.headimgurl,
            openid: this.userinfo.openid
          }
        })
      }
    },
    //获取用户获取的红包
    getUserRed () {
      if (this.user != null && this.user.id != null) {
        this.$api.post({
          url: '/merchant/api/activity/spread-list/find/un-give-red-paper/list',
          data: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            activityType: 0
          },
          login: false
        }).then(res => {
          this.redEnvelope = res.data
        })
      }
    },
    //用户领取红包
    getRedEnvelope (id, totalMoney) {
      if (this.user.uid != null && this.user.uid != '') {
        this.$router.push({
          path: '/MerTokerGetredEnvelope',
          query: {
            id: id,
            totalMoney: totalMoney,
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            activityType: 0,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            uid: this.user.uid
          }
        })
      } else {
        this.showBind = true
        this.checkType = 2
      }
    },
    //关闭遮罩窗口
    closePoster: function () {
      this.showPoster = false
      this.posterImg = ''
    },
    //绑定手机号
    bind (phone, code) {
      this.checkPhone(phone) //校验手机号
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/bind/phone/nocode',
        data: {
          codeNum: code,
          phone: phone,
          merId: this.urlParam.merId,
          openid: this.userinfo.openid,
          fansid: this.user.id,
          storeId: this.urlParam.storeId,
          sourceType: this.formObj.sourceType,
          nickname: this.userinfo.nickname
        },
        login: false
      }).then(res => {
        location.reload()
      })
    },
    closeMask: function () {  //隐藏 表单
      if (this.activityTime != 3) {
        this.isMask = false
        this.isEnd = false
      }
    },
    //获取倒计时时间
    cutDownTimeFun: function () {
      let cutDownTime = this.cutDownTime
      cutDownTime--
      this.cutDownTime = cutDownTime
      if (cutDownTime == 0) {
        this.clearTime()
        this.activityTime = 0
        this.timeId = setInterval(this.showDateTime, 1000) //执行的定时器 ;
      }
    },
    checkPhone: function (phone) {
      let reg = /^1\d{10}$/
      let myreg = /^0\d{2,3}-?\d{7,8}$/
      if (!reg.test(phone) && !myreg.test(phone)) {
        alert('请填写的正确的手机号码格式')
        return
      }
    },
    //生成海报
    draw () {
      this.showPoster = true
      if (this.posterImg == '') {
        const opts = {
          useCORS: true
        }
        this.$nextTick(() => {
          let url = window.location.href.split('?')[0] + '?activityId=' + this.urlParam.activityId
            + '&merId=' + this.urlParam.merId + '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price
            + '&spreadOpenid=' + this.userinfo.openid
          let canvas1 = qrcanvas({
            data: decodeURIComponent(url), //分享链接（根据需求来）
            size: window.screen.availWidth * 0.2 //二维码大小
          })
          document.getElementById('qrcode').innerHTML = ''
          document.getElementById('qrcode').appendChild(canvas1)
          window.pageYoffset = 0
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          html2canvas(this.$refs.box, opts).then(canvas => {
            this.posterImg = canvas.toDataURL('image/png')
          })
        })
      }
    },
  },
  watch: {
    'activityData.backgroundMusic': function (val) {
      if (val != null && val != '') {
        setTimeout(() => {   //设置延迟执行
          this.$refs.musicPlay.play()
        }, 1000)
      }
    }
  }
  /**
   * 到达这个组件时
   * @param to
   * @param from
   * @param next
   */
  /*beforeRouteEnter(to, from, next) {
    next(vm=>{
      if (vm.$refs.follow && vm.$refs.follow.$data.dialogShow)
        vm.$refs.follow.closeDialog ()
    })
  },*/
  /**
   * 离开这个组件时
   * @param to
   * @param from
   * @param next
   */
  /*beforeRouteLeave(to, from, next) {
    this.$refs.follow.closeDialog ()
    next()
  }*/
}
</script>


<style scoped>
body {
  display: block;
  margin: auto !important;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.item-div {
  width: 100%;
  height: 100%;
  margin-top: 50px;
}

.item-div .item-top {
  width: 100%;
  background-size: 100% 100%;
  margin: 0px auto;
  padding: 0px;
}

.item-div .item-top .top-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  border: none;
  color: rgba(239, 231, 255, 1);
  position: fixed;
  top: 0px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 4;
  text-align: center;
  font-size: 0.42rem;
}

.item-div .item-top .service {
  align-items: center;
  padding: 1vw;
  height: 10vw;
  position: fixed;
  top: 10vh;
  width: 10vw;
  right: 1vw;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  background-image: url("../../resource/img/active/lxsj.png");
  background-size: inherit;
}

.item-div .item-top .poster {
  align-items: center;
  padding: 1vw;
  height: 10vw;
  position: fixed;
  top: 20vh;
  width: 10vw;
  right: 1vw;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  background-image: url("../../resource/img/active/wdhb.png");
  background-size: inherit;
}


.item-div .item-top .music-btn {
  width: 10vw;
  height: 10vw;
  float: right;
  position: fixed;
  top: 1%;
  right: 3%;
  z-index: 4;
  animation: rotate 2s linear infinite;
}

.item-div .item-content {
  width: 100%;
  height: 100%;
  margin-top: -1vh;
}


.item-div .item-content .time-div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 3;
  text-align: center;
}

.item-div .item-content .time-div .time-img {
  width: 90%;
  height: 12vh;
  display: inline-block;
  margin-top: 20px;
}

.item-div .item-content .time-div .time-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 0.4rem;
  width: 100%;
  color: #fff;
  height: 12vh;
  padding-top: 20px;
}

.item-div .item-content .time-div .time-content .time-title {
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.item-div .item-content .time-div .time-content .time-text {
  width: 0.5rem;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 0.5rem;
  color: black;
  font-size: 0.38rem;
}

.item-div .item-content .time-div .time-content span {
  font-size: 0.29rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}


.item-div .item-content .content-div {
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 1vh;
}

.item-div .item-content .content-div .sm-icon {
  height: 20px;
  color: white;
  width: 100%;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.item-div .item-content .content-div .sm-icon span {
  font-size: 0.296667rem;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}

.item-div .item-content .content-div .user-info {
  line-height: 4vh;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.item-div .item-content .content-div .user-info .avatar-img {
  width: 15vw;
  height: 15vw;
  border-radius: 50%
}

.item-div .item-content .content-div .user-info .name {
  font-size: 3.5vw;
  text-align: left;
  margin-left: 1vw;
}

.item-div .item-content .content-div .diamond-div {
  margin-top: 10px;
}

.item-div .item-content .content-div .diamond-div > img {
  width: 7vw;
  height: 6.5vw;
  margin: 0 10px 10px 0;
}

.item-div .item-content .content-div .content-div-text {
  line-height: 4vh;
  font-size: 0.3rem;
  color: rgba(255, 255, 255, 1);
  font-family: 'Times New Roman', Times, serif;
}

.item-div .item-content .content-div .content-title {
  height: 6vh;
  color: rgba(239, 231, 255, 1);
  background: rgba(0, 0, 0, 0.3);
  font-size: 0.4rem;
  font-weight: lighter;
  line-height: 6vh;
  font-family: "微软雅黑";
}

.item-div .item-content .content-div .red-envelope-div {
  padding: 2px;
  max-height: 450px;
  background-color: #5a0707;
  border-radius: 10px;
  margin: 10px 10px 0 10px;
}

.item-div .item-content .content-div .red-envelope-div .content {
  max-height: 450px;
  border-radius: 20px;
  overflow-y: auto;
}

.item-div .item-content .content-div .red-envelope-div .content .red-envelope-list {
  margin: 0 2.5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.item-div .item-content .content-div .red-envelope-div .content .red-envelope-list .span-div {
  height: 100%;
  color: #fff;
  font-size: 14px;
  line-height: 50px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}

.item-div .item-content .content-div .red-envelope-div .content .red-envelope-list .span-div > span {
  color: #fff100;
}


.item-div .item-content .content-div .red-envelope-div .content .red-envelope-list .get-btn {
  height: 30px;
  color: #fff100;
  line-height: 30px;
  background-color: #ec5254;
  border-radius: 5px;
  text-align: center;
  padding: 0 15px;
}


.item-div .item-content .content-div .red-envelopes {
  height: 40vw;
  color: #f1be36;
  font-family: "微软雅黑";
  border-collapse: collapse;
  border-spacing: 5px;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.133333rem;
  margin: 20px 10px 0% 10px;
  color: white;
}

.item-div .item-content .content-div .red-envelopes .title-caption {
  display: flex;
  align-items: center;
  height: 40px;
}

.item-div .item-content .content-div .red-envelopes .title-caption .img {
  width: 5vw;
  height: 5.86vw;
  margin-right: 10px;
}

.item-div .item-content .content-div .red-envelopes .title-caption .text {
  font-size: 3.5vw;
}

.item-div .item-content .content-div .red-envelopes .top-tr {
  height: 5vw;
  background: rgba(0, 0, 0, 0.3);
  width: 100%
}

.item-div .item-content .content-div .red-envelopes .ranking-img {
  width: 5vw;
  height: 5.5vw;
  vertical-align: middle
}


.item-div .item-content .content-div .red-paper-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  margin: 20px 10px 0 10px;
}


.item-div .item-content .content-div .red-paper-list .goods-content {
  height: 16vh;
  display: -webkit-box;
  display: -ms-flexbox;
  -ms-flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: 2vh 0vh;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 95%;
  height: 100%;
  justify-content: space-between;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .goods-img {
  width: 30%;
  height: 100%;
  margin-right: 10px;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .user-content {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex: 1;
  font-size: 3.5vw;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .user-content .name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .user-content .price {
  padding: 3vw 0px;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .lock-img {
  height: 40px;
  width: 31px;
}

.item-div .item-content .content-div .red-paper-list .goods-content .content .lock-div {
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.item-div .item-content .content-div .red-paper-list .goods-content .content .lock-div .get-btn {
  width: 100%;
  height: 5vw;
  background: linear-gradient(180deg, rgb(159, 192, 242) 0%, rgb(221, 214, 228) 100%);
  box-shadow: 0px 2px 10px 0px rgba(199, 88, 43, 0.5);
  border-radius: 5vw;
  border: none;
  margin-top: 3vw;
  outline: none;
  color: rgba(245, 166, 35, 1);
  font-size: 0.255rem;
}


.item-div .item-content .content-div .order-list {
  height: 39vh;
  min-height: 27vh;
  max-height: 39vh;
  color: white;
}

.item-div .item-content .content-div .order-list .table {
  border-collapse: collapse;
  width: 100vw;
}

.item-div .item-content .content-div .order-list .table .tr {
  border-bottom: 1px dashed white;
}

.item-div .item-content .content-div .order-list .table .avatar-img {
  width: 15vw;
  height: 15vw;
  border-radius: 50%
}

.item-div .item-content .content-div .order-display {
  height: auto;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
}

.item-div .item-content .content-div .order-display div {
  width: 16vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8px;
}

.item-div .item-content .content-div .order-display .avatar-img {
  width: 8vw;
  height: 8vw;
  border-radius: 10vw
}

.item-div .item-content .content-div .order-display .name {
  font-size: 2vw;
  color: white;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  width: 14vw
}

.item-div .item-content .btn_img {
  width: auto;
  height: auto;
  max-width: 50%;
  max-height: 100%;
  margin-top: 20px;
  margin-bottom: 15px;
}

.item-div .item-bottom {

}

.item-div .item-bottom .bg-img {
  width: 100%;
  height: 100%;
}

.item-div .item-bottom .fool-img {
  background-image: url("../../resource/img/底部.png");
  width: 100%;
  background-size: 100% 100%;
  position: fixed;
  bottom: 0px;
  text-align: center;
}

.item-div .item-bottom .fool-img .img {
  width: 80px;
  height: 80px;
}

.buy-div {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(214, 75, 44, 1) 0%, rgba(235, 116, 66, 1) 100%);
  width: 80%;
  height: 5rem;
  display: inline-block;
  border-radius: 0.1rem;
  padding-left: 5px;
}

.buy-div .title {
  margin-top: 4px;
  margin-bottom: 4px;
  color: rgb(238, 210, 204);
  font-size: 12px;
  margin-left: 5%;
}

.buy-div input {
  padding-left: 2%;
  width: 88%;
  height: 18%;
  background: rgba(255, 255, 255, 1);
  margin-left: 5%;
  border-radius: 0.1rem;
  border: none;
  outline: none;
}

.buy-div .buy-btn {
  margin-top: 5%;
  width: 60%;
  height: 18%;
  margin-left: 20%;
  border-radius: 20px;
  border: none;
  outline: none;
  background: linear-gradient(180deg, rgba(242, 235, 159, 1) 0%, rgba(210, 143, 42, 1) 100%);
  -webkit-box-shadow: 0 0.026667rem 0.133333rem 0 rgba(199, 88, 43, 0.5);
  box-shadow: 0 0.026667rem 0.133333rem 0 rgba(199, 88, 43, 0.5);
  border-radius: 0.6rem;
  text-align: center;
  color: #d65538;
  border: 0.013333rem solid rgba(222, 156, 159, 1);
}

.textDiv font {
  flex-shrink: 1;
  color: #eed2cc;
  font-size: 18px;
  margin-left: 0.3rem;
}

.textDiv input {
  flex-shrink: 1;
  width: 86%;
  height: 4vh;
  margin-top: 0.1rem;
  margin-left: 0.3rem;
  background: rgba(238, 210, 204, 1);
  border-radius: 0.133333rem;
}


.close-img {
  width: 30px;
  height: 30px;
  margin-top: 15px;
}

.Unlockname {
  width: 80%;
  height: auto;
  margin-left: 8%;
  display: contents;
}

.mask {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
}

.mask.service {
  display: flex;
  justify-content: center;
}

.mask.buy {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.mask.poster {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.service-div {
  width: 45vh;
  height: max-content;
  background-color: white;
  font-size: 15px;
  margin-top: 20%;
  display: block;
  text-align: center;
  border-radius: 10px;
}

.service-div .name-span {
  margin: 10px;
}

.service-div .phone-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 15px 20px 0px 20px;
}

.service-div .phone-div .btn-style {
  height: 28px;
  line-height: 28px;
  border-radius: 23px;
  border: 1px solid #f40000;
  background-color: #f40000;
  color: #fff;
  padding: 0 20px;
  outline: none;
}

.service-div .bottom-text {
  margin-bottom: 20px;
  color: #9B9B9B;
  font-size: 13px;
}

.bind-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 75%;
  height: 4.5rem;
  background-color: white;
  text-align: left;
  border-radius: 10px;
}

.bind-div p {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  margin-left: 3vw;
  font-size: 0.5rem
}

.bind-div input {
  width: 90%;
  height: 20%;
  border-radius: 0.266667rem;
  border: none;
  background: rgba(231, 231, 231, 1);
  outline: none;
  padding: 0 10px;
}

.bind-div .bind-img {
  width: 40%;
  height: 18%;
  margin-top: 5%
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg); /* IE 9 */
    -moz-transform: rotate(0deg); /* Firefox */
    -o-transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg); /* IE 9 */
    -moz-transform: rotate(360deg); /* Firefox */
    -o-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}


.red-paper-rank {
  display: flex;
  flex-direction: column;
  width: 90vw;
  height: auto;
  justify-content: space-between;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.form-content {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.titleInfo {
  width: 90%;
  height: 25%;
  display: none;
  position: fixed;
  top: 10%;
  z-index: 7;
  left: 5%;
  background-color: #ffffff;
}

table tr td {
  font-size: 3.5vw;
}

.poster-box {
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 75%;
  height: auto;
  position: absolute;
  padding: 5px;
  z-index: 10;
  top: 20px;
  margin-top: 7%;
}

.poster-box .top-img {
  width: 100%;
  height: auto;
}

.poster-box .user {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}

.poster-box .user .logo-img {
  width: 15%;
  border-radius: 50%;
  margin-right: 10px;
}

.poster-box .user .span-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.poster-box .user .span-info .user-name {
  color: #ed6942;
  font-size: 15px;
}

.poster-box .user .span-info .text-span {
  color: peru;
  font-size: 13px;
  margin-top: 5px;
}

.poster-box .share-title {
  font-size: 16px;
  font-weight: 800;
  margin-top: 5px;
}

.poster-box .bottom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
  padding: 0 25px 0 30px;
}

.poster-box .bottom-div .discern-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70px;
}

.poster-box .bottom-div .discern-div .discern-img {
  width: 50px;
  height: 50px;
}


.poster-box .bottom-div .discern-div .span-text {
  color: #ed6942;
  font-size: 14px;
  font-weight: 800;
}

.posterImg {
  flex-direction: column;
  display: flex;
  z-index: 10;
  align-content: center;
  align-items: center;
  width: 70%;
  height: auto;
  position: absolute;
  top: 0px;
}

.posterImg {
  position: absolute;
  z-index: 7;
  top: 20px;
  width: 75%;
}

.posterImg .title-hint {
  color: white;
  margin-bottom: 3%;
  font-size: 15px;
  font-weight: 800;
}

.posterImg > img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerDetail.vue